// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2SQwn","title":"Images90_title__2qoSr","images":"Images90_images__Lhqyp"};